<script lang="ts">
  import { DesktopClose } from "@tastyworks/icons"

  interface Props {
    onStop: () => void
  }

  let { onStop }: Props = $props()
</script>

<button
  type="button"
  class="__cbio_ignored fixed right-0 bottom-6 z-[2147483647] flex translate-x-[calc(100%-44px)] cursor-pointer overflow-hidden rounded-l-lg shadow-[-2px_2px_8px_rgba(0,0,0,0.2)] transition-transform duration-[250ms] ease-[ease] hover:translate-x-0 focus-visible:translate-x-0 focus-visible:outline-hidden"
  onclick={onStop}
>
  <div
    class="bg-button-red flex h-11 w-11 shrink-0 items-center justify-center text-black"
  >
    <DesktopClose class="size-5" />
  </div>
  <div
    class="bg-button-red text-icon-general-inverted flex items-center gap-2 px-4 py-[10px] whitespace-nowrap"
  >
    <span class="text-[13px] font-semibold">Stop Sharing</span>
  </div>
</button>
